import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "end-header" }

import IconComponent from '@/components/IconComponent.vue';
import IconArrowLeft from '@/assets/VueIcons/IconArrowLeft.vue';
import { isPhone } from '@/utils/responsiveHelper';

export default /*#__PURE__*/_defineComponent({
  __name: 'EndHeader',
  props: {
  title: String
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/end/menu",
      class: "back-navigation"
    }, {
      default: _withCtx(() => [
        _createVNode(IconComponent, null, {
          default: _withCtx(() => [
            _createVNode(IconArrowLeft)
          ]),
          _: 1
        }),
        _createTextVNode(_toDisplayString(_unref(isPhone)() ? '' : 'Back'), 1)
      ]),
      _: 1
    }),
    _createElementVNode("p", null, _toDisplayString(__props.title), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})